<template>
    <div ref="modal" @keyup.esc="close()" class="modal" v-bind="$attrs" tabindex="-1">
        <div class="modal-dialog" v-bind:class="dialog">
            <div class="modal-content">
                <div class="modal-header" v-if="needHeader" v-bind:class="header">
                    <slot name="header">
                        <div class="me-3">
                            <span class="fw-bolder h3" @click.self="close()" data-bs-dismiss="modal" aria-label="Close">
                                <i class="fal fa-times text-primary"></i>
                            </span>
                        </div>
                        <div class="w-100 pe-3 text-truncate">
                            <span class="fw-bolder h4">
                                <slot name="title">Title</slot>
                            </span>
                        </div>
                        <div class="flex-shrink-1">
                            <slot name="save">
                                <button class="btn btn-primary btn-sm rounded-pill px-3 pe-3">Save</button>
                            </slot>
                        </div>
                    </slot>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div class="modal-footer" v-if="needFooter">
                    <slot name="footer">
                        <button @click="close" type="button" class="btn btn-lg btn-outline-secondary rounded-pill" data-bs-dismiss="modal">{{$t('app.close')}}</button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Modal',
        props: {
            needHeader: {
                type: Boolean,
                default: true
            },
            needFooter: {
                type: Boolean,
                default: false
            },
            size: {
                value: '',
                default: 'lg'
            },
            background: {
                value: '',
                default: ''
            },
            dialog: {
                value: '',
                default: ''
            },
            backdrop: {
                value: '',
                default: true
            },
            header: {
                value: '',
                default: true
            },

        },
        data() {
            return {
                modal:null,
            }
        },
        mounted() {
            this.modal = new bs.Modal(this.$refs.modal,{backdrop:this.backdrop});
            this.$refs.modal.addEventListener('hidden.bs.modal',  () => {
                this.$emit('close');
            })

        },
        beforeUnmount() {
            this.$emit('close');
        },
        methods: {
            open() {
                this.modal.show()
            },
            close() {
                this.modal.hide()
            }
        },

    }

</script>
<style scoped lang="scss">

        .modal-header.error{
            background: var(--bs-danger);
            color: white;
        }
</style>
